import { FunctionalComponent, h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { Item } from './TocPropsTypes';

export interface ListItemProps extends Item {
	hasFocus: boolean;
}
export const TocMobileItem: FunctionalComponent<ListItemProps> = (props) => {
	const me = useRef<HTMLAnchorElement>(null);
	useEffect(() => {
		if (props.hasFocus && me.current) {
			me.current.focus();
		}
	});
	return (
		<li className="SP-TocList__item">
			<a href={props.href} tabIndex={-1} ref={me} className="SP-Link SP-Toc__link">
				<span className="SP-Link__text">
					<span className="SP-Link__title">{props.label}</span>
				</span>
			</a>
		</li>
	);
};
